import { supabase } from './supabaseClient'

// ── FIX #3: Email now goes through Supabase Edge Function ────────────────────
// Previously called /api/send-email which doesn't exist in Create React App.
// Deploy the Edge Function from supabase/functions/send-email/index.ts
// then enable it in your Supabase project dashboard.
export async function sendEmail(type, to, data) {
  if (!to) return
  try {
    const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kolkata'
    const { error } = await supabase.functions.invoke('send-email', {
      body: { type, to, data: { ...data, studentTZ: data?.studentTZ || userTZ } },
    })
    if (error) {
      console.warn('Email send failed (non-critical):', error.message)
    }
  } catch (e) {
    console.warn('Email send failed (non-critical):', e.message)
  }
}
